/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Monatlichezahlungen1Inputs */



/**

* @param {_Field_Monatlichezahlungen1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_monatlichezahlungen1 = /** @type {((inputs?: _Field_Monatlichezahlungen1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Monatlichezahlungen1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Monatliche Zahlungen")
});
export { _field_monatlichezahlungen1 as "_field_monatlicheZahlungen" }